import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Spinner + label for a loading button. One canonical shape used
 * everywhere so the whole app looks the same while actions are in
 * flight — never bare "..." or just a greyed-out label.
 *
 *   <Button disabled={loading}>
 *     {loading ? <LoadingLabel text="Saving" /> : "Save"}
 *   </Button>
 */
export function LoadingLabel({
  text,
}: {
  text?: string;
}) {
  const { t } = useTranslation();
  return (
    <span className="inline-flex items-center gap-1.5">
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
      {text ?? t("miscUi.loading")}…
    </span>
  );
}
